module.exports = __webpack_public_path__ + "media/images/list-menu-closed-b9aa0d46.svg";